import { useCallback } from 'react';

// The hook now takes a generic E which should be an enum of valid ids
export function useScrollToId<E extends { [key: string]: string }>(options?: ScrollIntoViewOptions) {
  return useCallback(
    async (id: E[keyof E]) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView(options || { behavior: 'smooth', block: 'start' });
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, 1000);
      });
    },
    [options]
  );
}

export function useWaitAndScrollToId<E extends { [key: string]: string }>(options?: ScrollIntoViewOptions) {
  return useCallback(
    (id: E[keyof E], delay: number = 1500) => {
      const waitForElementsRender = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView(options || { behavior: 'smooth', block: 'start', inline: 'nearest' });
          return;
        }

        const observer = new MutationObserver(() => {
          const element = document.getElementById(id);
          if (element) {
            observer.disconnect();
            element.scrollIntoView(options || { behavior: 'smooth', block: 'start', inline: 'nearest' });
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      };

      setTimeout(waitForElementsRender, delay);
    },
    [options]
  );
}
